import React from 'react';
import ExpandableContainer from '../ExpandableContainer';
import formatPrice from '../pricing/priceFormatter'
import Summary from '../pricing/summary';
import {hideSummary} from '../helpers/pricingHelpers';

export default class SummaryPricingSection extends React.Component {

    pricingTableRef = React.createRef()
    pricingSummaryRef = React.createRef()

    priceColumns = ['FactoryCost', 'Price']

    stepAboutToBecomeVisible = () => {
        let summary = this.pricingSummaryRef.current
        let table = this.pricingTableRef.current

        hideSummary(summary, this.getPricing().items)

        if (summary && table) {
            let finalPriceHeader = table.querySelectorAll('th[data-slug="Final"]')[0]

            // Wait for React to render the component.
            setTimeout(() => {

                // Now wait for the animation to end, because it changes the dimensions.
                setTimeout(() => {
                    summary.style.position = 'relative'
                    summary.style.left = (finalPriceHeader.offsetLeft - table.offsetLeft) + 'px'
                    $(summary).animate({'opacity': 1}, 100)
                }, 200)
            })
        }
    }

    renderCell = (item, column) => {
        if (this.priceColumns.includes(column.slug)) {
            return formatPrice(item[column.slug.firstCharacterLowerCase()])
        }

        return item[column.slug.firstCharacterLowerCase()]
    }

    getPricing() {
        if (this.props.model.topArticleNumberPricing.items.items.length > 0) {
            return this.props.model.topArticleNumberPricing;
        }

        return this.props.model.pricing;
    }

    render() {
        const model = this.getPricing();
        const columns = model.items.columns.toJS().filter(x => x.visible);

        return (
            <ExpandableContainer label={__('Pricing')} onOpen={this.stepAboutToBecomeVisible}>
                <div
                    className={[model.items.visible ? '' : '--only-configuration-editor-pricing-summary', 'responsive-table-container'].join(' ')}>
                    {model.items.visible &&
                        <table className="configuration-editor-summary-pricing" ref={this.pricingTableRef}>
                            <thead>
                            <tr>
                                <th style={{textAlign: 'center'}}>#</th>
                                {columns.map(column => (
                                    <th key={column.slug} data-slug={column.slug}>{column.name}</th>
                                ))}
                            </tr>
                            </thead>

                            <tbody>
                            {model.items.items.map((item, idx) => (
                                <tr key={idx}>
                                    <td>
                                        <span>{idx + 1}.</span>
                                    </td>

                                    {columns.map((column, idx) => (
                                        <td key={idx}
                                            className={`column-${column.slug}`}>{this.renderCell(item, column)}</td>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>}

                    <Summary sref={this.pricingSummaryRef} model={model}/>
                </div>
            </ExpandableContainer>
        )
    }
}